export default __webpack_public_path__ + "static/scribe-fe5e9099e38a43a2d8980fdc88612207.png";